var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardGroup2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "208px",
    height: "78px",
    viewBox: "0 0 208 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-20.0%",
    width: "140.0%",
    height: "140.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00612881425   0 0 0 0 0.174103402   0 0 0 0 0.39806952  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Convert-to-2.0-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "convert-old-dashboard-to-new-one---prompt-to-users",
    transform: "translate(-616.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(616.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(169.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99915228,-4.0397772e-16 L29.0008477,4.0397772e-16 C32.4777708,-2.34722689e-16 33.7385871,0.362019883 35.0096982,1.04181754 C36.2808094,1.72161521 37.2783848,2.71919065 37.9581825,3.99030176 C38.6379801,5.26141287 39,6.52222919 39,9.99915228 L39,29.0008477 C39,32.4777708 38.6379801,33.7385871 37.9581825,35.0096982 C37.2783848,36.2808094 36.2808094,37.2783848 35.0096982,37.9581825 C33.7385871,38.6379801 32.4777708,39 29.0008477,39 L9.99915228,39 C6.52222919,39 5.26141287,38.6379801 3.99030176,37.9581825 C2.71919065,37.2783848 1.72161521,36.2808094 1.04181754,35.0096982 C0.362019883,33.7385871 1.56481793e-16,32.4777708 -2.6931848e-16,29.0008477 L2.6931848e-16,9.99915228 C-1.56481793e-16,6.52222919 0.362019883,5.26141287 1.04181754,3.99030176 C1.72161521,2.71919065 2.71919065,1.72161521 3.99030176,1.04181754 C5.26141287,0.362019883 6.52222919,2.34722689e-16 9.99915228,-4.0397772e-16 Z",
    id: "Rectangle",
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99915228,-4.0397772e-16 L29.0008477,4.0397772e-16 C32.4777708,-2.34722689e-16 33.7385871,0.362019883 35.0096982,1.04181754 C36.2808094,1.72161521 37.2783848,2.71919065 37.9581825,3.99030176 C38.6379801,5.26141287 39,6.52222919 39,9.99915228 L39,29.0008477 C39,32.4777708 38.6379801,33.7385871 37.9581825,35.0096982 C37.2783848,36.2808094 36.2808094,37.2783848 35.0096982,37.9581825 C33.7385871,38.6379801 32.4777708,39 29.0008477,39 L9.99915228,39 C6.52222919,39 5.26141287,38.6379801 3.99030176,37.9581825 C2.71919065,37.2783848 1.72161521,36.2808094 1.04181754,35.0096982 C0.362019883,33.7385871 1.56481793e-16,32.4777708 -2.6931848e-16,29.0008477 L2.6931848e-16,9.99915228 C-1.56481793e-16,6.52222919 0.362019883,5.26141287 1.04181754,3.99030176 C1.72161521,2.71919065 2.71919065,1.72161521 3.99030176,1.04181754 C5.26141287,0.362019883 6.52222919,2.34722689e-16 9.99915228,-4.0397772e-16 Z",
    id: "Rectangle-Copy-7",
    fill: "#AEEDEE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Regular",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750000, 11.700000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    stroke: "#000000",
    strokeWidth: 1.29675,
    x: 0,
    y: 0,
    width: 19.5,
    height: 15.6,
    rx: 1.29675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 3.9,
    x2: 19.5,
    y2: 3.9,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.29675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9,
    y1: 7.8,
    x2: 11.7,
    y2: 7.8,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.29675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.3,
    y1: 11.7,
    x2: 11.7,
    y2: 11.7,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.29675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.85,
    y1: 7.15,
    x2: 5.85,
    y2: 12.35,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.29675
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.25,
    y1: 9.75,
    x2: 8.45,
    y2: 9.75,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.29675
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(126.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0758145,1.28538972e-15 L37.9241855,5.28278557e-16 C42.4709311,-3.06945055e-16 44.1196909,0.473410617 45.7819131,1.36237679 C47.4441353,2.25134296 48.748657,3.55586469 49.6376232,5.21808691 C50.5265894,6.88030913 51,8.52906895 51,13.0758145 L51,37.9241855 C51,42.4709311 50.5265894,44.1196909 49.6376232,45.7819131 C48.748657,47.4441353 47.4441353,48.748657 45.7819131,49.6376232 C44.1196909,50.5265894 42.4709311,51 37.9241855,51 L13.0758145,51 C8.52906895,51 6.88030913,50.5265894 5.21808691,49.6376232 C3.55586469,48.748657 2.25134296,47.4441353 1.36237679,45.7819131 C0.473410617,44.1196909 -8.49163463e-16,42.4709311 1.46148257e-15,37.9241855 L3.52185705e-16,13.0758145 C-2.04630037e-16,8.52906895 0.473410617,6.88030913 1.36237679,5.21808691 C2.25134296,3.55586469 3.55586469,2.25134296 5.21808691,1.36237679 C6.88030913,0.473410617 8.52906895,-7.46848445e-16 13.0758145,1.28538972e-15 Z",
    id: "Rectangle",
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0758145,1.28538972e-15 L37.9241855,5.28278557e-16 C42.4709311,-3.06945055e-16 44.1196909,0.473410617 45.7819131,1.36237679 C47.4441353,2.25134296 48.748657,3.55586469 49.6376232,5.21808691 C50.5265894,6.88030913 51,8.52906895 51,13.0758145 L51,37.9241855 C51,42.4709311 50.5265894,44.1196909 49.6376232,45.7819131 C48.748657,47.4441353 47.4441353,48.748657 45.7819131,49.6376232 C44.1196909,50.5265894 42.4709311,51 37.9241855,51 L13.0758145,51 C8.52906895,51 6.88030913,50.5265894 5.21808691,49.6376232 C3.55586469,48.748657 2.25134296,47.4441353 1.36237679,45.7819131 C0.473410617,44.1196909 -8.49163463e-16,42.4709311 1.46148257e-15,37.9241855 L3.52185705e-16,13.0758145 C-2.04630037e-16,8.52906895 0.473410617,6.88030913 1.36237679,5.21808691 C2.25134296,3.55586469 3.55586469,2.25134296 5.21808691,1.36237679 C6.88030913,0.473410617 8.52906895,-7.46848445e-16 13.0758145,1.28538972e-15 Z",
    id: "Rectangle-Copy-3",
    fill: "#FAD278"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.750000, 12.750000)",
    id: "Regular",
    stroke: "#000000",
    strokeWidth: 1.69575
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.7148695,
    y1: 18.651125,
    x2: 12.7148695,
    y2: 22.042625,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.7148695,
    y1: 22.042625,
    x2: 9.3233695,
    y2: 25.434125,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.7148695,
    y1: 22.042625,
    x2: 16.1063695,
    y2: 25.434125,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.8446195,
    y: -0.002125,
    width: 23.7405,
    height: 18.65325,
    rx: 1.69575
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "4.2361195 10.172375 7.6276195 10.172375 9.3233695 6.780875 12.7148695 12.716 15.2584945 8.476625 17.8021195 10.172375 21.1936195 5.933"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99915228,-4.0397772e-16 L29.0008477,4.0397772e-16 C32.4777708,-2.34722689e-16 33.7385871,0.362019883 35.0096982,1.04181754 C36.2808094,1.72161521 37.2783848,2.71919065 37.9581825,3.99030176 C38.6379801,5.26141287 39,6.52222919 39,9.99915228 L39,29.0008477 C39,32.4777708 38.6379801,33.7385871 37.9581825,35.0096982 C37.2783848,36.2808094 36.2808094,37.2783848 35.0096982,37.9581825 C33.7385871,38.6379801 32.4777708,39 29.0008477,39 L9.99915228,39 C6.52222919,39 5.26141287,38.6379801 3.99030176,37.9581825 C2.71919065,37.2783848 1.72161521,36.2808094 1.04181754,35.0096982 C0.362019883,33.7385871 1.56481793e-16,32.4777708 -2.6931848e-16,29.0008477 L2.6931848e-16,9.99915228 C-1.56481793e-16,6.52222919 0.362019883,5.26141287 1.04181754,3.99030176 C1.72161521,2.71919065 2.71919065,1.72161521 3.99030176,1.04181754 C5.26141287,0.362019883 6.52222919,2.34722689e-16 9.99915228,-4.0397772e-16 Z",
    id: "Rectangle",
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99915228,-4.0397772e-16 L29.0008477,4.0397772e-16 C32.4777708,-2.34722689e-16 33.7385871,0.362019883 35.0096982,1.04181754 C36.2808094,1.72161521 37.2783848,2.71919065 37.9581825,3.99030176 C38.6379801,5.26141287 39,6.52222919 39,9.99915228 L39,29.0008477 C39,32.4777708 38.6379801,33.7385871 37.9581825,35.0096982 C37.2783848,36.2808094 36.2808094,37.2783848 35.0096982,37.9581825 C33.7385871,38.6379801 32.4777708,39 29.0008477,39 L9.99915228,39 C6.52222919,39 5.26141287,38.6379801 3.99030176,37.9581825 C2.71919065,37.2783848 1.72161521,36.2808094 1.04181754,35.0096982 C0.362019883,33.7385871 1.56481793e-16,32.4777708 -2.6931848e-16,29.0008477 L2.6931848e-16,9.99915228 C-1.56481793e-16,6.52222919 0.362019883,5.26141287 1.04181754,3.99030176 C1.72161521,2.71919065 2.71919065,1.72161521 3.99030176,1.04181754 C5.26141287,0.362019883 6.52222919,2.34722689e-16 9.99915228,-4.0397772e-16 Z",
    id: "Rectangle-Copy-8",
    fill: "#B5E4FC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-3)",
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.750000, 9.750000)",
    id: "Regular",
    stroke: "#000000",
    strokeWidth: 1.29675
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9.7231355,
    y1: 14.262625,
    x2: 9.7231355,
    y2: 16.856125,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.7231355,
    y1: 16.856125,
    x2: 7.1296355,
    y2: 19.449625,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.7231355,
    y1: 16.856125,
    x2: 12.3166355,
    y2: 19.449625,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.6458855,
    y: -0.001625,
    width: 18.1545,
    height: 14.26425,
    rx: 1.29675
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "3.2393855 7.778875 5.8328855 7.778875 7.1296355 5.185375 9.7231355 9.724 11.6682605 6.482125 13.6133855 7.778875 16.2068855 4.537"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(31.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0758145,1.28538972e-15 L37.9241855,5.28278557e-16 C42.4709311,-3.06945055e-16 44.1196909,0.473410617 45.7819131,1.36237679 C47.4441353,2.25134296 48.748657,3.55586469 49.6376232,5.21808691 C50.5265894,6.88030913 51,8.52906895 51,13.0758145 L51,37.9241855 C51,42.4709311 50.5265894,44.1196909 49.6376232,45.7819131 C48.748657,47.4441353 47.4441353,48.748657 45.7819131,49.6376232 C44.1196909,50.5265894 42.4709311,51 37.9241855,51 L13.0758145,51 C8.52906895,51 6.88030913,50.5265894 5.21808691,49.6376232 C3.55586469,48.748657 2.25134296,47.4441353 1.36237679,45.7819131 C0.473410617,44.1196909 -8.49163463e-16,42.4709311 1.46148257e-15,37.9241855 L3.52185705e-16,13.0758145 C-2.04630037e-16,8.52906895 0.473410617,6.88030913 1.36237679,5.21808691 C2.25134296,3.55586469 3.55586469,2.25134296 5.21808691,1.36237679 C6.88030913,0.473410617 8.52906895,-7.46848445e-16 13.0758145,1.28538972e-15 Z",
    id: "Rectangle",
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0758145,1.28538972e-15 L37.9241855,5.28278557e-16 C42.4709311,-3.06945055e-16 44.1196909,0.473410617 45.7819131,1.36237679 C47.4441353,2.25134296 48.748657,3.55586469 49.6376232,5.21808691 C50.5265894,6.88030913 51,8.52906895 51,13.0758145 L51,37.9241855 C51,42.4709311 50.5265894,44.1196909 49.6376232,45.7819131 C48.748657,47.4441353 47.4441353,48.748657 45.7819131,49.6376232 C44.1196909,50.5265894 42.4709311,51 37.9241855,51 L13.0758145,51 C8.52906895,51 6.88030913,50.5265894 5.21808691,49.6376232 C3.55586469,48.748657 2.25134296,47.4441353 1.36237679,45.7819131 C0.473410617,44.1196909 -8.49163463e-16,42.4709311 1.46148257e-15,37.9241855 L3.52185705e-16,13.0758145 C-2.04630037e-16,8.52906895 0.473410617,6.88030913 1.36237679,5.21808691 C2.25134296,3.55586469 3.55586469,2.25134296 5.21808691,1.36237679 C6.88030913,0.473410617 8.52906895,-7.46848445e-16 13.0758145,1.28538972e-15 Z",
    id: "Rectangle-Copy-6",
    fill: "#F986A6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-4)",
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.900000, 12.750000)",
    id: "Regular",
    stroke: "#000000",
    strokeWidth: 1.69575
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.81287472,
    y1: 9.3245,
    x2: 0.81287472,
    y2: 16.1075,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.2316747,
    y1: 0.84575,
    x2: 25.2316747,
    y2: 24.58625,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.81287472,
    y1: 11.02025,
    x2: 25.2316747,
    y2: 2.5415,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.81287472,
    y1: 14.41175,
    x2: 25.2316747,
    y2: 22.8905,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56314528,16.0611495 L5.56314528,16.1075 C5.65676128,19.2942792 7.65365506,22.0798537 10.5603963,23.0784341 C13.4671376,24.0770144 16.6630827,23.0753851 18.558288,20.5718445",
    id: "Shape"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    filter: "url(#filter-5)",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3833112,-6.21504185e-16 L44.6166888,6.21504185e-16 C49.9658012,-3.61111829e-16 51.9055187,0.556953667 53.8610742,1.60279622 C55.8166298,2.64863878 57.3513612,4.18337022 58.3972038,6.13892578 C59.4430463,8.09448133 60,10.0341988 60,15.3833112 L60,44.6166888 C60,49.9658012 59.4430463,51.9055187 58.3972038,53.8610742 C57.3513612,55.8166298 55.8166298,57.3513612 53.8610742,58.3972038 C51.9055187,59.4430463 49.9658012,60 44.6166888,60 L15.3833112,60 C10.0341988,60 8.09448133,59.4430463 6.13892578,58.3972038 C4.18337022,57.3513612 2.64863878,55.8166298 1.60279622,53.8610742 C0.556953667,51.9055187 2.4074122e-16,49.9658012 -4.14336123e-16,44.6166888 L4.14336123e-16,15.3833112 C-2.4074122e-16,10.0341988 0.556953667,8.09448133 1.60279622,6.13892578 C2.64863878,4.18337022 4.18337022,2.64863878 6.13892578,1.60279622 C8.09448133,0.556953667 10.0341988,3.61111829e-16 15.3833112,-6.21504185e-16 Z",
    id: "Rectangle",
    fill: "#7F4DFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-6)",
    id: "Group-5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.996170, 14.997500)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29.925,
    y1: 7.28306304e-14,
    x2: 10.9725,
    y2: 13.965,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.98,
    y1: 1.995,
    x2: 11.97,
    y2: 1.995,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.975,
    y1: -1.09245946e-13,
    x2: 9.975,
    y2: 3.99,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9975,
    y1: 9.975,
    x2: 6.9825,
    y2: 9.975,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.99,
    y1: 6.9825,
    x2: 3.99,
    y2: 12.9675,
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.80966,29.925 C23.48647,27.70523 23.21249,25.06252 23.06353,21.9849",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86147,21.9849 C6.71384,25.06385 6.43853,27.7039 6.11534,29.925",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.945,11.66277 C26.69177,12.66692 29.925,14.66059 29.925,16.9575 C29.925,20.26255 23.22579,22.9425 14.9625,22.9425 C6.69921,22.9425 -3.64153152e-13,20.26255 -3.64153152e-13,16.9575 C0.00119760107,16.6144119 0.0717723876,16.27511 0.20748,15.96",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.96,14.97447 C20.44875,15.08486 23.94,15.93074 23.94,16.9575 C23.94,18.05874 19.92074,18.9525 14.9625,18.9525 C10.00426,18.9525 5.985,18.05874 5.985,16.9575",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.995
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardGroup2);
export default __webpack_public_path__ + "static/media/dashboard_group_2.a9b311c9.svg";
export { ForwardRef as ReactComponent };